import validatorBuilder from 'validator-builder';

// CoordGeoDto class
class CoordGeoDto {
	constructor({
		longitude = '',
		latitude = '',
		numParcelle = null,
		feuilleCadastrale = null,
		sectionCadastrale = '',
		contenance = null,
		codeInsee = ''
	} = {}) {
		this.longitude = longitude;
		this.latitude = latitude;
		this.numParcelle = numParcelle;
		this.feuilleCadastrale = feuilleCadastrale;
		this.sectionCadastrale = sectionCadastrale;
		this.contenance = contenance;
		this.codeInsee = codeInsee;
	}
}

class PrestationDto {
	constructor({ id = null, code = '', libelle = '' } = {}) {
		this.id = id;
		this.code = code;
		this.libelle = libelle;
	}
}

// ChantierDto class
class ChantierDto {
	constructor({
		id = null,
		code = '',
		libelle = '',
		isContamine = false,
		isPotentielContamine = false,
		isChantierDuBatiment = null,
		isChantierReferenceBasias = false,
		isChantierReferenceBasol = false,
		isReferenceBasol = false,
		adresse = new AdresseDto(),
		coordGeo = new CoordGeoDto()
	} = {}) {
		this.id = id;
		this.code = code;
		this.libelle = libelle;
		this.isContamine = isContamine;
		this.isPotentielContamine = isPotentielContamine;
		this.isChantierDuBatiment = isChantierDuBatiment;
		this.isChantierReferenceBasias = isChantierReferenceBasias;
		this.isChantierReferenceBasol = isChantierReferenceBasol;
		this.isReferenceBasol = isReferenceBasol;
		this.adresse = adresse;
		this.coordGeo = coordGeo;
	}
}

// TransporteurDto class
class TransporteurDto {
	constructor({ id = null, code = '', libelle = '', isSignature = false } = {}) {
		this.id = id;
		this.code = code;
		this.libelle = libelle;
		this.isSignature = isSignature;
	}
}

// AdresseDto class
class AdresseDto {
	constructor({ adresse = '', ville = '', codePostal = '' } = {}) {
		this.adresse = adresse;
		this.ville = ville;
		this.codePostal = codePostal;
	}
}

// ContactDto class
class ContactDto {
	constructor({ id = null, code = '', nom = '', prenom = '', telMobile = '', telFix = '', adresse = new AdresseDto() } = {}) {
		this.id = id;
		this.code = code;
		this.nom = nom;
		this.prenom = prenom;
		this.telMobile = telMobile;
		this.telFix = telFix;
		this.adresse = adresse;
	}
}

// SiteDto class
class SiteDto {
	constructor({ id = null, code = '', libelle = '', adresse = new AdresseDto() } = {}) {
		this.id = id;
		this.code = code;
		this.libelle = libelle;
		this.adresse = adresse;
	}
}

// DechetDto class
class DechetDto {
	constructor({ id = null, code = '', libelle = '', quantite = 0, isDangereux = false, restriction = null, restrictionDocument = null } = {}) {
		this.id = id;
		this.code = code;
		this.libelle = libelle;
		this.quantite = quantite;
		this.isDangereux = isDangereux;
		this.restriction = restriction;
		this.restrictionDocument = restrictionDocument;
	}
}

class EcoOrganisme {
	constructor({ id = null, libelle = '' } = {}) {
		this.id = id;
		this.libelle = libelle;
	}
}

class Lieu {
	constructor({ id = null, libelle = '', coordGeo = new CoordGeoDto() } = {}) {
		this.id = id;
		this.libelle = libelle;
		this.coordGeo = coordGeo;
	}
}
// DapFullDto class (Dap)
export default class Dap {
	constructor({
		id = null,
		numero = '',
		dateCreation = new Date(),
		dateDebut = null,
		dateFin = null,
		etat = 1,
		isBLRefus = false,
		demandeur = new SiteDto(),
		siteProducteur = new SiteDto(),
		siteAccueil = new SiteDto(),
		producteur = new ContactDto(),
		chantier = new ChantierDto(),
		isSignatureClient = false,
		isSignatureProducteurDechet = false,
		dechets = [],
		transporteurs = [],
		controles = [],
		ecoOrganisme = new EcoOrganisme(),
		lieu = new Lieu(),
		idCoordGeo = 0
	} = {}) {
		this.id = id;
		this.numero = numero;
		this.dateCreation = dateCreation;
		this.dateDebut = dateDebut;
		this.dateFin = dateFin;
		this.etat = etat;
		this.isBLRefus = isBLRefus;
		this.demandeur = demandeur;
		this.siteProducteur = siteProducteur;
		this.siteAccueil = siteAccueil;
		this.producteur = producteur;
		this.chantier = chantier;
		this.isSignatureClient = isSignatureClient;
		this.isSignatureProducteurDechet = isSignatureProducteurDechet;
		this.dechets = dechets.map((dechet) => new DechetDto(dechet));
		this.transporteurs = transporteurs.map((transporteur) => new TransporteurDto(transporteur));
		this.controles = controles.map((controle) => new PrestationDto(controle));
		this.ecoOrganisme = ecoOrganisme;
		this.lieu = lieu;
		this.idCoordGeo = idCoordGeo;
	}

	isValid() {
		const dapValidator = validatorBuilder.getInstanceFor('DAP');
		const validationResults = dapValidator.validate(this);
		return validationResults.isValid;
	}
}
